import { z } from 'zod';

import type {
  EmployeeAssignmentDto,
  EmployeeAssignmentInput,
  GetEmployeeAssignmentsRequest,
  GetEmployeeAssignmentsResponse,
  ReplaceEmployeeAssignmentsRequest,
  ReplaceEmployeeAssignmentsResponse,
} from './employee-assignments.dto.js';
import { EmployeeDtoSchema } from './employees.schema.js';

const timestampSchema = z.iso.datetime();

export const EmployeeAssignmentDtoSchema: z.ZodType<EmployeeAssignmentDto> = z.object({
  companyId: z.uuid(),
  employeeId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid().nullable(),
  isPrimary: z.boolean(),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

export const EmployeeAssignmentInputSchema: z.ZodType<EmployeeAssignmentInput> = z.object({
  storeId: z.uuid(),
  locationId: z.uuid().nullable().optional(),
  isPrimary: z.boolean(),
});

export const GetEmployeeAssignmentsRequestSchema: z.ZodType<GetEmployeeAssignmentsRequest> = z.object({
  companyId: z.uuid(),
  employeeId: z.uuid(),
});

export const GetEmployeeAssignmentsResponseSchema: z.ZodType<GetEmployeeAssignmentsResponse> = z.object({
  items: z.array(EmployeeAssignmentDtoSchema),
});

export const ReplaceEmployeeAssignmentsRequestSchema: z.ZodType<ReplaceEmployeeAssignmentsRequest> = z.object({
  companyId: z.uuid(),
  employeeId: z.uuid(),
  assignments: z.array(EmployeeAssignmentInputSchema).min(1),
});

export const ReplaceEmployeeAssignmentsResponseSchema: z.ZodType<ReplaceEmployeeAssignmentsResponse> = z.object({
  employee: EmployeeDtoSchema,
  items: z.array(EmployeeAssignmentDtoSchema),
});
